<template>
  <div>
    <HeroSectionComponent data-aos="fade-up" data-aos-delay="100" />
    <AboutComponent data-aos="fade-up" data-aos-delay="300" />
  </div>
</template>

<script>
import { onMounted } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

import HeroSectionComponent from '@/components/ComponentHomeView/HeroSectionComponent.vue';
import AboutComponent from '@/components/ComponentHomeView/AboutComponent.vue';

export default {
  components: {
    HeroSectionComponent,
    AboutComponent
  },
  setup() {
    onMounted(() => {
      AOS.init({
        duration: 1000, // durée de chaque animation (ms)
        easing: "ease-in-out", // style fluide
        once: true, // joue l’animation une seule fois
        offset: 100, // distance avant que l’animation démarre
      });
    });
  }
};
</script>

<style>
/* Optionnel : transition douce entre les sections */
[data-aos] {
  opacity: 0;
  transform: translateY(20px);
  transition: all 1s ease;
}
[data-aos].aos-animate {
  opacity: 1;
  transform: translateY(0);
}
</style>